<template>
    <ion-page>
        <ion-header :translucent="true">
            <ion-toolbar>
                <ion-title color="white">Dettaglio nota spesa</ion-title>
                <ion-buttons slot="start">
                    <ion-button @click="closeModal()">
                        <ion-icon slot="start" :icon="arrowBackOutline" color="white"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>

        <ion-content :fullscreen="true">
            <div class="page_content">
                <div class="richiesta">
                    <div class="field">
                        <div class="title">Data</div>
                        <div class="value">
                            {{ dateFormat(spesa.nota_spese_data) }}
                        </div>
                    </div>
                    <div class="field">
                        <div class="title">Importo</div>
                        <div class="value">€ {{ spesa.nota_spese_importo }}</div>
                    </div>
                    <div class="field">
                        <div class="title">Stato</div>
                        <div class="value">
                            <div class="badge" :class="setStatusColor(spesa.nota_spese_stato)">{{ spesa.nota_spese_stato_value }}</div>
                        </div>
                    </div>
                    <div v-if="spesa.nota_spese_categoria" class="field_note">
                        <div class="title">Categoria</div>
                        <div class="value">
                            {{ spesa.nota_spese_categoria_value }}
                        </div>
                    </div>
                    <div v-if="spesa.nota_spese_descrizione" class="field_note">
                        <div class="title">Descrizione</div>
                        <div class="value">
                            {{ spesa.nota_spese_descrizione }}
                        </div>
                    </div>
                    <div class="field_ricevuta">
                        <div class="title">Foto ricevuta</div>
                        <div v-if="spesa.nota_spese_foto_ricevuta">
                            <!-- <img :src="setImageUrl(spesa.nota_spese_foto_ricevuta)" /> -->
                            <ion-img :src="setImageUrl(spesa.nota_spese_foto_ricevuta)"></ion-img>
                        </div>
                        <div v-else class="value">
                            Non hai caricato la foto della ricevuta
                        </div>
                    </div>
                </div>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    //IonBackButton,
    IonTitle,
    IonContent,
    IonIcon,
    IonButton,
    IonImg,
    modalController,
} from "@ionic/vue";
import { arrowBackOutline } from "ionicons/icons";

import { defineComponent, ref, computed } from "vue";

import { dateFormat } from "@/services/utils";

export default defineComponent({
    name: "NotaSpesaDetail",
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    components: {
        IonPage,
        IonHeader,
        IonToolbar,
        IonButtons,
        //IonBackButton,
        IonTitle,
        IonContent,
        IonIcon,
        IonButton,
        IonImg,
    },
    setup(props, context) {
        //console.log(props.data);
        const loading = ref(false);
        const spesa = ref([]);

        spesa.value = { ...props.data };
        //console.log(spesa.value);

        /**
         * Handle close modal by clicking on Chiudi button
         */
        const closeModal = () => {
            modalController.dismiss();
        };

        function setImageUrl(path) {
            return `${process.env.VUE_APP_BASE_URL}/uploads/${path}`;
        }

        const setStatusColor = computed(() => {
            return (statusId) => {
                let className = "";
                if (statusId == 1) {
                    //inserita
                    className = "badge_inserita";
                } else if (statusId == 2) {
                    //accettata
                    className = "badge_accettata";
                } else if (statusId == 3) {
                    //rifiutata
                    className = "badge_rifiutata";
                } else if (statusId == 4) {
                    //rimborsata
                    className = "badge_rimborsata";
                }
                return className;
            };
        });

        return {
            loading,
            dateFormat,
            spesa,
            arrowBackOutline,
            closeModal,
            setImageUrl,
            setStatusColor,
        };
    },
});
</script>

<style scoped>
ion-toolbar {
    --background: #086fa3;
    --color: #ffffff;
}
.loading_spinner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

ion-item {
    font-size: 14px;
}
ion-label {
    margin: 0;
}

.description_title {
    color: var(--ion-color-primary, #3880ff) !important;
    margin: 10px 0;
}

/* New rules */
.page_content {
    width: 100%;
    position: relative; /* to be used for new richiesta btn */
    padding: 16px;
    min-height: 100%;
    background: #f2f2f2;
}

.richiesta {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding: 10px;
    background: #ffffff;
    border-radius: 4px;
    margin-bottom: 10px;
    box-shadow: 0px 2px 3px 0px rgba(58, 58, 58, 0.1);
}
.richiesta .field {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0px;
    border-bottom: 1px solid #e2e8f0;
}
.richiesta .field_note {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 12px 0px;
    border-bottom: 1px solid #e2e8f0;
}
.richiesta .field_ricevuta {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    padding: 12px 0px;
}
.field .title,
.field_note .title,
.field_ricevuta .title {
    font-size: 14px;
    font-weight: 500;
    color: #1d1d1b;
}
.field_ricevuta .title {
    margin-bottom: 8px;
}
.field_note .title {
    margin-bottom: 8px;
}
.field .value,
.field_note .value,
.field_ricevuta .value {
    font-size: 14px;
    font-weight: 600;
    color: #1d1d1b;
}

.value .badge {
    font-size: 12px;
    font-weight: bold;
    color: #ffffff;
    padding: 4px 8px;
    border-radius: 4px;
}

.value .badge.badge_inserita {
    background-color: rgb(254 243 199);
    color: rgb(245 158 11);
}
.value .badge.badge_rimborsata {
    background-color: rgb(220 252 231);
    color: rgb(34 197 94);
}
.value .badge.badge_rifiutata {
    background-color: rgb(254 226 226);
    color: rgb(239 68 68);
}
.value .badge.badge_accettata {
    background-color: rgb(219 234 254);
    color: rgb(59 130 246);
}
ion-button {
    --color: #ffffff;
}
</style>
